import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHookSection } from '../components/OpeningHookSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedMethodsSection } from '../components/FailedMethodsSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { WhoIsThisForSection } from '../components/WhoIsThisForSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function SalesPage() {
  useEffect(() => {
    // Load Meta Pixel
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    window.fbq('init', '1436890408218834');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-background font-sans selection:bg-primary/20" data-id="element-271">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-272">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1436890408218834&ev=PageView&noscript=1" alt="" data-id="element-273" />
      </noscript>

      <main data-id="element-274">
        <HeroSection data-id="element-275" />
        <OpeningHookSection data-id="element-276" />
        <ProblemSection data-id="element-277" />
        <FailedMethodsSection data-id="element-278" />
        <MechanismSection data-id="element-279" />
        <WhatYouGetSection data-id="element-280" />
        <WhoIsThisForSection data-id="element-281" />
        <HowItWorksSection data-id="element-282" />
        <ProofSection data-id="element-283" />
        <FAQSection data-id="element-284" />
        <OfferSection data-id="element-285" />
      </main>

      <Footer data-id="element-286" />
    </div>;
}